// src/hooks/useInvoiceProjectData.js
import { useState, useEffect, useCallback } from "react";
import { fetchInvoiceProjectData } from "../utils/fetchInvoiceProjectData";
import { transformInvoiceData } from "../utils/transformInvoiceData";

export const useInvoiceProjectData = (limit, initialFilters = {}) => {
    const [projects, setProjects] = useState([]);
    const [filteredProjects, setFilteredProjects] = useState([]);
    const [loading, setLoading] = useState(true);

    // Set initial filters
    const [filters, setFilters] = useState(initialFilters);

    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
            const mergedData = await fetchInvoiceProjectData(limit);
            const formattedData = mergedData.map(transformInvoiceData);
            setProjects(formattedData);
            setFilteredProjects(formattedData);
            setLoading(false);
        };
        loadData();
    }, [limit]);

    // Function to apply filters based on filter values
    const applyFilters = useCallback(() => {
        const filtered = projects.filter((project) =>
            Object.keys(filters).every((key) =>
                filters[key] ? project[key]?.toString().toLowerCase().includes(filters[key].toLowerCase()) : true
            )
        );
        setFilteredProjects(filtered);
    }, [filters, projects]);

    useEffect(() => {
        applyFilters();
    }, [filters, applyFilters]);

    // Function to change filters and reapply them
    const onFilterChange = (key, value) => {
        setFilters((prev) => ({ ...prev, [key]: value }));
    };

    return { projects: filteredProjects, loading, onFilterChange };
};
